var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.218 18.945a1.543 1.543 0 1 1 0 3.086 1.543 1.543 0 0 1 0-3.086m10.378 0a1.543 1.543 0 1 1 0 3.086 1.543 1.543 0 0 1 0-3.086m-10.378 1.2a.344.344 0 0 0 0 .687.344.344 0 0 0 0-.687m10.378 0a.344.344 0 1 0 .001.688.344.344 0 0 0 0-.688M4.493 2.012a.6.6 0 0 1 .587.473l.908 4.244H21.51a.6.6 0 0 1 .586.729l-1.556 7.01a2.49 2.49 0 0 1-2.425 1.95H8.889a2.49 2.49 0 0 1-2.473-1.964L4.007 3.211H2.606a.6.6 0 1 1 0-1.2zm3.095 12.19a1.29 1.29 0 0 0 1.287 1.017h9.239a1.29 1.29 0 0 0 1.255-1.01v-.002l1.394-6.28H6.245z"
  })));
};
export default SvgShoppingCart;